import gql from 'graphql-tag';

export default gql`
  mutation UpdateStakeholder(
    $firstName: String
    $lastName: String
    $dob: DateTime
    $country: String
    $homeNumber: String
    $cellNumber: String
    $email: String
    $idNumber: String
    $residentialAddress: String
    $postalAddress: String
    $unitNumber: String
    $status: StakeholderStatus
    $role: StakeholderRole
    $id: ID!
    $properties: PropertyUpdateInput
  ) {
    updateStakeholder(
      data: {
        firstName: $firstName
        lastName: $lastName
        dob: $dob
        country: $country
        homeNumber: $homeNumber
        cellNumber: $cellNumber
        email: $email
        idNumber: $idNumber
        residentialAddress: $residentialAddress
        postalAddress: $postalAddress
        unitNumber: $unitNumber
        status: $status
        role: $role
        properties: $properties
      }
    id: $id
    ) {
      createdAt
      updatedAt
      id
      firstName
      lastName
      dob
      country
      cellNumber
      email
      idNumber
      residentialAddress
      postalAddress
      unitNumber
      status
      role
      properties {
        createdAt
        id
        code
        updatedAt
        address
        size
        valuation
        rooms
        erfNumber
        status
        salesAgent
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/mutations/UpdateStakeholder.ts